import Vue from 'vue';
import { api } from "../../services/Api.js";
import { modalService } from '../../services/ModalService.js';
import i18n from "../../language.js";

export function delete_pdf({ state, commit }, payload ){

    // adding token
    payload.token=state.appSettings.token


    modalService.createModal(i18n.t('language.document_delete_sure')).then(
      ()=>{
          // get active school
          var school = state.user_schools.find(school => school.active === 1);
          
          // make api call
          api
            .post(school,"delete_pdf.php",payload)
            .then( () =>{ 
              
            
              var item=state.documents[payload.store_key].find(item => item.id === payload.id);
              
              if(item){
                
                let index = state.documents[payload.store_key].indexOf(item);
                
                commit('DELETE_DOCUMENT', {key:payload.store_key ,index:index});

              }
            
              Vue.$toaster.toast("language.pdf_delete_success");

            })
            .catch( error => {
              
              Vue.$toaster.toast("store: delete_pdf: "+error);
            })


      },
      () => {} // cancel modal
      )// modal

         
    
  }

